import { render } from "./ModalPublishDone.vue?vue&type=template&id=0542bf80&scoped=true"
import script from "./ModalPublishDone.vue?vue&type=script&lang=js"
export * from "./ModalPublishDone.vue?vue&type=script&lang=js"

import "./ModalPublishDone.vue?vue&type=style&index=0&id=0542bf80&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0542bf80"]])

export default __exports__